<template>
	<ListDisplay
		heading-data-test="task-list-section-heading"
		empty-data-test="no-tasks-message"
		load-more-data-test="load-more-tasks-button"
		:sectionTitle="sectionTitle"
		:sectionDescription="sectionDescription"
		:updateStatus="taskUpdateStatus"
		:continuationKey="continuationKey"
		:noItemsMessage="noTasksMessage"
		:canLoadMore="canLoadMore"
		:dataLoaded="dataLoaded"
		:hasItems="!!taskList && taskList.length > 0"
		@retry="$emit('retry')"
	>
		<template #skeleton>
			<TaskCardSkeleton />
		</template>

		<template #items>
			<TaskCard
				v-for="task in taskList"
				:key="task.TaskID"
				:taskID="task.TaskID"
				:taskData="task"
			/>
		</template>

		<template #loadMoreButton>
			<slot name="loadMoreButton">
				<v-btn
					variant="outlined"
					width="auto"
					:loading="taskUpdateStatus?.loading"
					@click="$emit('load-more-tasks')"
				>
					Load more tasks
				</v-btn>
			</slot>
		</template>
	</ListDisplay>
</template>

<script lang="ts">
import { Task } from "@/types/api/tasks";
import { RemoteAccessState } from "@/types/general";
import { defineComponent, PropType } from "vue";

// Components
import ListDisplay from "@/components/TaskManager/ListDisplay.vue";
import TaskCard from "@/components/TaskManager/TaskCard.vue";
import TaskCardSkeleton from "@/components/TaskManager/TaskCardSkeleton.vue";

export default defineComponent({
	name: "TaskListDisplay",
	components: { ListDisplay, TaskCard, TaskCardSkeleton },
	props: {
		sectionTitle: { type: String, required: true },
		sectionDescription: { type: String, required: true },
		taskList: { type: Array as PropType<Task[]>, default: () => [] },
		taskUpdateStatus: { type: Object as PropType<RemoteAccessState> },
		continuationKey: { type: String },
		tasksLoadingMessage: { type: String, required: true },
		noTasksMessage: { type: String, required: true },
		canLoadMore: { type: Boolean, default: false },
		dataLoaded: { type: Boolean, default: true },
	},
	emits: { "load-more-tasks": () => true, retry: () => true },
});
</script>
